//import TextBookFindListArea from "@/pages/comp/book_order/textbook/common/find_list";
import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "@/pages/comp/book_order/textbook/common/list/area/search";
import ManageBtnArea from "./area/manage_btn";

function TextBookFindListArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_title_like: "",
    s_category_seq: "",
    s_sort1_seq: "",
    s_sort2_seq: "",
    s_sort3_seq: "",
    s_subject:"",
    s_addon_textbook_sort: "1",
    s_addon_section: "1",
    s_addon_study: "1",
    s_addon_product: "1",
    ...myProps.listOpt
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const select_finish = (inData: any) => {
    let selected_rows = ListComponentRef.current.getSelectedRows();
    let opt_obj = {
      selected_rows: selected_rows,
      ...inData
    };
    selected_rows = opt_obj.selected_rows;
    if (selected_rows.length == 0) {
      alert("선택된 교재가 없습니다.");
      return;
    }

    myProps.callbackData({
      info_arr: selected_rows,
    });
    myProps.closePopup();
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    if (params.key === "row_view_sort1") {
      if (params.rowData.bsort1_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort1_title} name="bsort1_title"
            onChange={(e: any) => { }} title={params.rowData.bsort1_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_sort2") {
      if (params.rowData.bsort2_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort2_title} name="bsort2_title"
            onChange={(e: any) => { }} title={params.rowData.bsort2_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_sort3") {
      if (params.rowData.bsort3_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort3_title} name="bsort3_title"
            onChange={(e: any) => { }} title={params.rowData.bsort3_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_category") {
      if (params.rowData.bcategory_title) {
        params.value = (
          <input type='text' value={params.rowData.bcategory_title} name="bcategory_title"
            onChange={(e: any) => { }} title={params.rowData.bcategory_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_stock_cnt") {
      if (params.rowData.product_info) {
        params.value = strFunc.comma(params.rowData.product_info.a_stock_cnt);
      }
    } else if (params.key === "row_view_price") {
      if (params.rowData.product_info) {
        let sum_price = parseInt(strFunc.uncomma(params.rowData.product_info.a_price));
        sum_price += parseInt(strFunc.uncomma(params.rowData.product_info.a_price_tax));

        params.value = strFunc.comma(sum_price);
      }
    } else if (params.key == "row_view_price_use") {
      if (params.rowData.product_info_use) {
        let sum_price = parseInt(strFunc.uncomma(params.rowData.product_info_use.a_price));
        sum_price += parseInt(strFunc.uncomma(params.rowData.product_info_use.a_price_tax));

        params.value = strFunc.comma(sum_price);
      }
    }

    return params.value;
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
      ></SearchArea>
      <ManageBtnArea
        select_finish={select_finish}
      ></ManageBtnArea>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "center",
            height: "auto",
            is_fix_width: true,
            rowMultiSelectWithClick: false,
            onGridReady: () => {

            },

            is_all_select_row_key: true,
            rowOnClick: rowOnClick,
            customCellRenderer: customCellRenderer,
            class_name_json: {
              table_div: "basic_list_div",
              td_div: "row-col-div",
              input_check: "chk_row",
              row_input: "row-input",
              data_row_tr: "data_row_tr",
              active_row: "active",
              empty_con_div: "list_empty_content_div",
            },
          }}
        ></ListComponent>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        is_view_num_per_page={true}
        is_show_total_rec={true}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
    </div>
  );
};
export default TextBookFindListArea;